<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div>
	<h1>Fancy Checkbox</h1>
	<div class="harness-flex harness-component-small-width">
		<fancy-checkbox [formControl]="smallCheckbox"></fancy-checkbox>
		<fancy-checkbox [formControl]="mediumCheckbox" class="medium-checkbox"></fancy-checkbox>
		<fancy-checkbox [formControl]="largeCheckbox" class="large-checkbox"></fancy-checkbox>
	</div>
	<br />
	<button (click)="setCheckbox(mediumCheckbox)">Toggle medium checkbox via code</button>
	<p>
		small: {{ smallCheckbox.valueChanges | async }}, medium: {{ mediumCheckbox.valueChanges | async }}, large:
		{{ largeCheckbox.valueChanges | async }}
	</p>
</div>

<div>
	<h1>Loading Blocker</h1>
	<button (click)="setLoadingInProgress()">Load</button><button (click)="setLoadingEmpty()">Empty</button
	><button (click)="setLoadingFailure()">Fail</button><button (click)="setLoadingComplete()">Complete</button>
	<div style="position: relative; border: 1px solid black">
		<!-- <ng-template *loadingBlocker="loadingState" (onStateChange)="logHarnessOutput($event)"></ng-template> -->
		<ng-template [loadingBlocker]="loadingState" (onStateChange)="logHarnessOutput($event)"></ng-template>
		Content inside the loading blocker <br />
		<input />
	</div>
	<button (click)="startLoadingObs = !startLoadingObs">Start observable version</button>
	<div *ngIf="startLoadingObs" style="position: relative; border: 1px solid black">
		<!-- <ng-template *loadingBlocker="loadingState" (onStateChange)="logHarnessOutput($event)"></ng-template> -->
		<ng-template
			[loadingBlocker]="loadingObservable | async"
			(onStateChange)="logHarnessOutput($event)"
		></ng-template>
		Content inside the loading blocker <br />
		<input />
	</div>
</div>

<div>
	<h1>Popup</h1>
	<button (click)="testPopup()" class="input-spacing-h">Open Popup</button>
	<button (click)="testPopup(true)" class="input-spacing-h">Open Popup Wrapped</button>
	<button (click)="testParentPopup(true)" class="input-spacing-h">Open Parent Popup</button>
	<button (click)="testParentPopup()" class="input-spacing-h">Open Parent Popup no blocking</button>
	<button (click)="testMultiPopup()" class="input-spacing-h">Open Multi Popup</button>
	<!-- popup testing, this one just opens inline -->
	<div style="position: relative; height: 300px">
		<ng-template popup-anchor></ng-template>
	</div>
</div>
